// extracted by mini-css-extract-plugin
export var calendarView = "_ms-0";
export var dayButton = "_ms-1";
export var dayCircle = "_ms-2";